import React, { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";

import Wrapper from "./App/components/Wrapper/Wrapper";

import Login from "./App/Layout/Auth/Login";
import Userlogin from "./App/Layout/Auth/Userlogin";
import Signup from "./App/Layout/Auth/Signup";
import Forgetpassword from "./App/Layout/Auth/Forgetpassword";
import Forgetpassworduser from "./App/Layout/Auth/Forgetpassworduser";

import "bootstrap/dist/css/bootstrap.min.css";
import NotificationListener from "./Utils/Notificationalert";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Notfound from "./App/Routes/NotFound";

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const Token = localStorage.getItem("token");
  const Role = localStorage.getItem("Role");




  useEffect(() => {
    const cleanedPath = location.pathname
      .trim()
      .toLowerCase()
      .replace(/\/+$/, "");

    if (cleanedPath !== location.pathname.toLowerCase()) {
      navigate(cleanedPath, { replace: true });
    }
  }, [location.pathname, navigate]);




  useEffect(() => {
    let path = location.pathname.trim().toLowerCase();


    if (path === "/") {
      navigate("/user-login", { replace: true });
      return;
    }

    const publicRoutes = [
      "/login",
      "/user-login",
      "/register",
      "/forget",
      "/forget-user",
      "/notfound"
    ];

    const isPublic = publicRoutes.includes(path);


    if (!isPublic && !Token) {
      navigate("/notfound", { replace: true });
      return;
    }


    if (Token) {
      if (path === "/login" || path === "/user-login" || path === "/") {
        switch (Role) {
          case "SUPERADMIN":
            navigate("/superadmin/company", { replace: true });
            break;
          case "ADMIN":
            navigate("/admin/dashboard", { replace: true });
            break;
          case "USER":
            navigate("/user/dashboard", { replace: true });
            break;
          case "EMPLOYEE":
            navigate("/employee/dashboard", { replace: true });
            break;
          default:
            navigate("/user-login", { replace: true });
        }
      }
    }
  }, [Token, Role, location.pathname, navigate]);

  return (
    <>
      <NotificationListener />
      <ToastContainer />

      <div className="App">
        <Routes>


          <Route path="/login" element={<Login />} />
          <Route path="/user-login" element={<Userlogin />} />
          <Route path="/register" element={<Signup />} />
          <Route path="/forget" element={<Forgetpassword />} />
          <Route path="/forget-user" element={<Forgetpassworduser />} />



          {Token && Role && <Route path="/*" element={<Wrapper />} />}


          <Route path="/notfound" element={<Notfound />} />
          <Route path="*" element={<Notfound />} />
        </Routes>
      </div>
    </>
  );
};

export default App;
